import React from 'react';

import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import styled, { css, CssUtilityType } from '../../../styled';
import { colorsPalette, TINY_MARGIN_PX } from '../../../theme';

export interface CategoryLabelProps {
  name: string;
  bgColor?: string;
  textColor?: string;
  className?: string;
  textCss?: CssUtilityType;
  url?: string | null;
  withDots?: boolean;
  textMaxWidth?: `${string}px`;
  Icon?: React.FC<any>;
}

const CategoryLabel: React.FC<CategoryLabelProps> = ({
  name,
  bgColor = colorsPalette.blue,
  textColor = colorsPalette.white,
  className = '',
  url = '',
  withDots = true,
  textMaxWidth,
  Icon,
  ...rest
}) => {
  if (url) {
    return (
      <CategoryLabelLink
        data-testid={rest['data-testid']}
        className={className}
        to={url}
        bgColor={bgColor}
      >
        {Icon && <StyledIcon as={Icon} />}
        <CategoryTitle
          optionalStyles={withDots && generatedWithDots(textMaxWidth)}
          textColor={textColor}
          textMaxWidth={textMaxWidth}
        >
          {name}
        </CategoryTitle>
      </CategoryLabelLink>
    );
  }

  return (
    <CategoryLabelWrapper data-testid={rest['data-testid']} className={className} bgColor={bgColor}>
      {Icon && <StyledIcon as={Icon} />}
      <CategoryTitle
        optionalStyles={withDots && generatedWithDots(textMaxWidth)}
        textColor={textColor}
        textMaxWidth={textMaxWidth}
      >
        {name}
      </CategoryTitle>
    </CategoryLabelWrapper>
  );
};

export default CategoryLabel;

const createCategoryLabel = (tag) => styled(tag, {
  shouldForwardProp: (prop) => prop !== 'bgColor' && prop !== 'optionalStyles',
})`
  border-radius: 5px;
  background: ${({ bgColor }) => bgColor};
  padding: 4px 9px 5px;
  display: inline-flex;
  align-items: center;

  && {
    ${({ optionalStyles }) => optionalStyles}
  }
`;
const CategoryLabelLink = createCategoryLabel(Link);
const CategoryLabelWrapper = createCategoryLabel(Box);

const StyledIcon = styled('div', {
  shouldForwardProp: (prop) => prop !== 'as',
})`
  width: 16px;
  height: 16px;
  margin-right: ${TINY_MARGIN_PX};
  margin-top: 2px;
`;
const CategoryTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'textColor' && prop !== 'optionalStyles',
})`
  color: ${({ textColor }) => textColor};
  font-weight: bold;
  font-size: 14px;
  line-height: 1.4;

  ${({ optionalStyles }) => optionalStyles}
`;
const generatedWithDots =
  (textMaxWidth) =>
  ({ theme }) =>
    css`
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 100px;

      ${theme.breakpoints.up('md')} {
        max-width: ${textMaxWidth || '125px'};
      }
    `;
